import type { i18n as I18n } from "i18next";
import en from "@/locales/en/duels/chess.json";
import fr from "@/locales/fr/duels/chess.json";

export const CHESS_DUEL_NS = "duels/chess";

/** Adds this duel's translations to an initialised i18next instance (idempotent). */
export function registerChessDuelTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", CHESS_DUEL_NS))
    i18n.addResourceBundle("en", CHESS_DUEL_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", CHESS_DUEL_NS))
    i18n.addResourceBundle("fr", CHESS_DUEL_NS, fr, true, true);
}
